import { imageFromUuid } from '../../helpers/utility';
import malePic from "../../assets/images/patient_male.png";
import femalePic from "../../assets/images/patient_female.png";


const ImgHolder = ({ uuid }) => {
    
    let url = imageFromUuid(uuid);

    if(uuid == 'female'){
        url = femalePic
    }
    else if(uuid == 'male'){
        url = malePic
    }

  return (
    <img src={url} className="h-full w-full rounded-full object-cover" alt="" />
  );
};

export default ImgHolder;